
import { defineComponent, ref, onMounted } from "vue";
import { hideModal } from "@/core/helpers/dom";
import { ApiBase, ApiMerchant, ApiApp } from "@/core/api";
import Swal from "sweetalert2/dist/sweetalert2.js";
import mixin from "@/mixins";
import _ from "lodash";

export default defineComponent({
  name: "add-app-modal",
  components: {},
  emits: ["update-list", "reset-form"],
  setup(props, { emit }) {
    const formRef = ref<null | HTMLFormElement>(null);
    const addAppModalRef = ref<null | HTMLElement>(null);
    const submitButton = ref<HTMLElement | null>(null);
    const loading = ref<boolean>(false);
    const {
      showValidateErrorMsg,
      showFormSubmitSuccessMsg,
      showServerErrorMsg,
    } = mixin();

    const formData = ref({
      status: 10,
      name: "",
      short_key: "",
      email: "",
      website: "",
      telephone: "",
      telephone2: "",
      fax: "",
      merchant_id: "",
      address: "",
      zip_code: "",
      city: "",
      country_iso_2: "",
      overall_notes: "",
      app_type: "",
    });

    const parentCompanys = ref([]);
    const appTypes = ref([]);
    const rules = ref({
      name: [
        {
          required: true,
          message: "App Name is required",
          trigger: "change",
        },
      ],
      short_key: [
        {
          required: true,
          message: "App Short-Key is required",
          trigger: "change",
        },
      ],
      telephone: [
        {
          required: true,
          message: "Telephone is required",
          trigger: "change",
        },
      ],

      app_type: [
        {
          required: true,
          message: "App Type is required",
          trigger: "change",
        },
      ],

      merchant_id: [
        {
          required: true,
          message: "Parent Merchant is required",
          trigger: "change",
        },
      ],
    });

    const getAppTypeOptions = () => {
      ApiBase.getTaggingData({ short_key: "global_app_type" })
        .then(({ data }) => {
          if (data.code == 0) {
            appTypes.value = data.data.items;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const submit = () => {
      if (!formRef.value) {
        return;
      }

      formRef.value.validate((valid) => {
        if (valid) {
          loading.value = true;
          if (submitButton.value) {
            submitButton.value.setAttribute("data-kt-indicator", "on");
          }
          ApiApp.addApp(formData.value)
            .then(({ data }) => {
              loading.value = false;
              submitButton.value?.removeAttribute("data-kt-indicator");
              if (data.code == 0) {
                showFormSubmitSuccessMsg(() => {
                  resetForm();
                  hideModal(addAppModalRef.value);
                  emit("update-list");
                });
              } else {
                showServerErrorMsg(data);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          showValidateErrorMsg();
          return false;
        }
      });
    };
    const getMerchantSourceData = async (value, id?) => {
      let params = id
        ? {
            id: id,
          }
        : {
            search_value: value,
          };
      const { data } = await ApiBase.getMerchantSourceData(params);
      if (data.code == 0) {
        parentCompanys.value = data.data;
      }
    };

    const debounceMerchantSourceSearch = _.debounce(
      getMerchantSourceData,
      1000
    );

    const searchMerchantSourceItems = (query: string) => {
      debounceMerchantSourceSearch(query);
    };

    const handleDiscard = () => {
      hideModal(addAppModalRef.value);
      resetForm();
    };

    const resetForm = () => {
      formRef.value?.resetFields();
    };

    onMounted(() => {
      getAppTypeOptions();
    });

    return {
      loading,
      formData,
      rules,
      formRef,
      addAppModalRef,
      parentCompanys,
      appTypes,
      submitButton,
      submit,
      handleDiscard,
      resetForm,
      searchMerchantSourceItems,
    };
  },
});
